import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=58b3b28f&scoped=true&"
import script from "./Register.js?vue&type=script&lang=js&"
export * from "./Register.js?vue&type=script&lang=js&"
import style0 from "./Register.scss?vue&type=style&index=0&id=58b3b28f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b3b28f",
  null
  
)

export default component.exports